import { render, staticRenderFns } from "./HelperMessage.vue?vue&type=template&id=71cb3368&scoped=true"
var script = {}
import style0 from "./HelperMessage.vue?vue&type=style&index=0&id=71cb3368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb3368",
  null
  
)

export default component.exports